import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KakobuySpreadsheetGuide from "../pages/article/kakobuy-spreadsheet-guide/page";
import KakobuyVsCssbuy from "../pages/article/kakobuy-vs-cssbuy/page";
import KakobuySafetyGuide from "../pages/article/kakobuy-safety-guide/page";
import KakobuyShoesSpreadsheet from "../pages/article/kakobuy-shoes-spreadsheet/page";
import KakobuyClothingSpreadsheet from "../pages/article/kakobuy-clothing-spreadsheet/page";
import CssbuySpreadsheet from "../pages/article/cssbuy-spreadsheet/page";
import SuperbuySpreadsheet from "../pages/article/superbuy-spreadsheet/page";
import OopbuySpreadsheet from "../pages/article/oopbuy-spreadsheet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <KakobuySpreadsheetGuide />,
  },
  {
    path: "/kakobuy-vs-cssbuy",
    element: <KakobuyVsCssbuy />,
  },
  {
    path: "/kakobuy-safety-guide",
    element: <KakobuySafetyGuide />,
  },
  {
    path: "/kakobuy-shoes-spreadsheet",
    element: <KakobuyShoesSpreadsheet />,
  },
  {
    path: "/kakobuy-clothing-spreadsheet",
    element: <KakobuyClothingSpreadsheet />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <CssbuySpreadsheet />,
  },
  {
    path: "/superbuy-spreadsheet",
    element: <SuperbuySpreadsheet />,
  },
  {
    path: "/oopbuy-spreadsheet",
    element: <OopbuySpreadsheet />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;